import { Component, Inject, OnInit, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ToastrService } from 'ngx-toastr';
import { Overtime } from 'src/app/_model/overtime';
import { WfApproveRequest } from 'src/app/_model/request/WfApproveRequest';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { OvertimeService } from 'src/app/_services/overtime.service';

@Component({
  selector: 'app-overtime-approve-selected',
  templateUrl: './overtime-approve-selected.component.html',
  styleUrls: ['./overtime-approve-selected.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class OvertimeApproveSelectedComponent implements OnInit {

  request: WfApproveRequest = new WfApproveRequest();
  currentUser: User;
  constructor(public dialogRef: MatDialogRef<OvertimeApproveSelectedComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Overtime[],
    private overtimeService: OvertimeService,
    private authService: AuthenticationService,
    private toastr: ToastrService) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit() {
  }
  approveSelected() {

    this.data.forEach(element => {
      this.request.employeeId = this.currentUser.employeeId;
      this.request.operationRecordId = element.id;
      this.request.operationTableName = 'OVERTIME';
      this.request.fileList = [];
      this.overtimeService.approveOvertime(this.request).subscribe(result => {
        this.toastr.success('Onaylama işlemi başarılı', '');
        this.dialogRef.close();
      }, error => {
        this.toastr.error(error.error.msg, 'Hata');
        this.dialogRef.close();
      });
    });

  }
}
